import {
  EnumCalendlyUrls,
  EnumMultipleWithCiclos,
  EnumMultipleWithMultiWithoutCiclos,
  EnumMultipleWithoutMultiWithoutCiclos,
  EnumOnlyCajuMais,
  EnumOnlyCiclos,
  EnumOnlyDespesas,
  EnumOnlyMulti,
  EnumOnlyRewards,
} from "./enums";
import { IStep3FormValues } from "pages/home/step3/useStep3Form/iStep3FormValues";
import { calculateProductMappings } from "pages/home/step3/productsList/productMapping";
import {
  Solutions,
  Subscriptions,
} from "pages/home/step3/productsList/productConstants";

export const getCalendlyLink = (
  step3Values?: IStep3FormValues,
  employeesNumber?: number | ""
) => {
  if (!employeesNumber || !step3Values) return;

  const {
    solutions: interestSolutions,
    subscriptions: interestSubscriptionProducts,
  } = calculateProductMappings(step3Values.selectedProducts);

  if (step3Values.selectedProducts.length === 1) {
    const hasOnlySolutions =
      interestSolutions.length > 0 && interestSubscriptionProducts.length === 0;
    const hasOnlySubscriptions =
      interestSubscriptionProducts.length > 0 && interestSolutions.length === 0;

    if (hasOnlySolutions) {
      return getLinkFromOneSolution(interestSolutions[0], employeesNumber);
    }
    if (hasOnlySubscriptions) {
      return getLinkFromOneSubscriptionProduct(
        interestSubscriptionProducts[0],
        employeesNumber
      );
    }
  }

  return getLinkFromManyProducts(
    interestSolutions,
    interestSubscriptionProducts,
    employeesNumber
  );
};

function getLinkFromOneSolution(solution: string, employeesNumber: number) {
  if (
    solution === Solutions.MULTIBENEFITS_VR_VA ||
    solution === Solutions.MULTIBENEFITS_FLEXIBLE
  ) {
    if (employeesNumber >= 100) return EnumOnlyMulti["100+"];
    if (employeesNumber >= 20) return EnumOnlyMulti["20-99"];
    return EnumOnlyMulti["1-19"];
  }

  if (solution === Solutions.AWARDS) {
    if (employeesNumber >= 100) return EnumOnlyRewards["100+"];
    if (employeesNumber >= 20) return EnumOnlyRewards["20-99"];
    return EnumOnlyRewards["1-19"];
  }

  if (solution === Solutions.EXPENSES) {
    if (employeesNumber >= 100) return EnumOnlyDespesas["100+"];
    if (employeesNumber >= 20) return EnumOnlyDespesas["20-99"];
    return EnumOnlyDespesas["1-19"];
  }

  return EnumCalendlyUrls.MASSIVO__ALL;
}

function getLinkFromOneSubscriptionProduct(
  product: string,
  employeesNumber: number
) {
  if (
    product === Subscriptions.HEALTH_NR1 ||
    product === Subscriptions.HEALTH_WELLHUB ||
    product === Subscriptions.HEALTH_OPTUM_CONEXA
  ) {
    if (employeesNumber >= 100) return EnumOnlyCajuMais["100+"];
    if (employeesNumber >= 20) return EnumOnlyCajuMais["20-99"];
    return EnumOnlyCajuMais["1-19"];
  }

  if (product === Subscriptions.PEOPLE_MANAGEMENT) {
    if (employeesNumber >= 50) return EnumOnlyCiclos["50+"];
    return EnumOnlyCiclos["1-49"];
  }

  return EnumCalendlyUrls.MASSIVO__ALL;
}

function getLinkFromManyProducts(
  interestSolutions: string[],
  interestSubscriptionProducts: string[],
  employeesNumber: number
) {
  if (employeesNumber < 20) return EnumCalendlyUrls.MASSIVO__ALL;

  const hasCiclos = interestSubscriptionProducts.includes(
    Subscriptions.PEOPLE_MANAGEMENT
  );
  const hasMulti = interestSolutions.some(
    (solution) =>
      solution === Solutions.MULTIBENEFITS_VR_VA ||
      solution === Solutions.MULTIBENEFITS_FLEXIBLE
  );

  if (hasCiclos) {
    if (employeesNumber >= 100) return EnumMultipleWithCiclos["100+"];
    return EnumMultipleWithCiclos["20-99"];
  }

  if (!hasCiclos && hasMulti) {
    if (employeesNumber >= 100)
      return EnumMultipleWithMultiWithoutCiclos["100+"];
    return EnumMultipleWithMultiWithoutCiclos["20-99"];
  }

  if (!hasCiclos && !hasMulti) {
    if (employeesNumber >= 100)
      return EnumMultipleWithoutMultiWithoutCiclos["100+"];
    return EnumMultipleWithoutMultiWithoutCiclos["20-99"];
  }

  return EnumCalendlyUrls.MASSIVO__ALL;
}
